/*@flow*/
import getId from 'lib/getId';
import { state } from 'ops';

export default function getDashboardId(): any {
  return state('$query.load.dashboardId') || getId('dashboards');
}
